<div
  class="position-relative rounded p-y-30 p-x-24 m-b-30 overflow-hidden"
  style="background-color: #ffca34; min-height: 100px;"
  *ngIf="pageInfo?.['title'] != 'Analytical' && pageInfo?.['title'] != 'eCommerce'">

  <!-- Ícone fixo no canto direito -->
  <img
    src="/assets/images/breadcrumb/vaidegas.png"
    alt="breadcrumb"
    style="position: absolute; top: 50%; right: 24px; transform: translateY(-50%); max-height: 60px;"
  />

  <!-- Conteúdo textual -->
  <div>
    <h4 class="page-title m-0 f-s-20 f-w-600 m-b-16">
      {{ pageInfo?.['title'] }}
    </h4>
    <div class="d-flex align-items-center overflow-hidden">
      <ng-template ngFor let-url [ngForOf]="pageInfo?.['urls']" let-last="last">
        <li class="breadcrumb-item" *ngIf="!last" [routerLink]="url.url">
          <a [routerLink]="url.url">{{ url.title }}</a>
        </li>
        <li class="breadcrumb-item active" *ngIf="last">{{ url.title }}</li>
      </ng-template>
    </div>
  </div>
</div>
